import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private subject = new Subject<any>();
  private isLoading$$ = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoading$$.asObservable();
  public isLoading = new BehaviorSubject(false);
  constructor() { }

  notify(notification: any) {
    this.subject.next({ notification });
  }

  getNotification(): Observable<any> {
    return this.subject.asObservable();
  }

  setLoading(isLoading: boolean) {
    this.isLoading$$.next(isLoading);
  }
}
